module.exports = __webpack_public_path__ + "media/images/games/35gender/gymnast-1adb44946a574195bc9f9a2b977d0db9.png";